import { query, where, collection, limit } from 'firebase/firestore';
import { size as _size } from 'lodash-es';
import { dbFirestore } from '../appFirebase';
import { getQueryData } from './dbUtils';

export const getSessionLookup = async () => {
	const sessionLookupRef = collection(dbFirestore, 'sessionLookup');
	const sessionLookupQ = query(sessionLookupRef, where('status', '==', 'active'), limit(1));
	const sessionLookupResults = await getQueryData(sessionLookupQ, 'sessionLookupId');
	if (_size(sessionLookupResults)) {
		return sessionLookupResults[0];
	}
};
